import { render } from "./EncuentroFooter.vue?vue&type=template&id=67469a4a&scoped=true"
import script from "./EncuentroFooter.vue?vue&type=script&lang=js"
export * from "./EncuentroFooter.vue?vue&type=script&lang=js"

import "./EncuentroFooter.vue?vue&type=style&index=0&id=67469a4a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-67469a4a"

export default script